import React from 'react';
import { instituteMock } from '../data/mock';

const Insurance = () => {
  const { insurance } = instituteMock;

  return (
    <section className="section-padding-small">
      <div className="container">
        <div className="insurance-content">
          <h2 className="heading-1" style={{ marginBottom: '16px', textAlign: 'center' }}>
            {insurance.title}
          </h2>
          <p className="body-large" style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
            {insurance.description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Insurance;
